/**
 * Рассчитывает позицию fixed-контекстного меню так, чтобы оно не выходило
 * за границы viewport и сохраняло минимальный отступ от края экрана.
 *
 * @param {MouseEvent|PointerEvent|Object} event событие открытия меню с clientX/clientY
 * @param {Object} options параметры размеров меню и viewport
 * @param {number} options.menuWidth ширина меню в пикселях
 * @param {number} options.menuHeight высота меню в пикселях
 * @param {number} options.viewportWidth ширина viewport
 * @param {number} options.viewportHeight высота viewport
 * @param {number} options.offset минимальный отступ от края viewport
 * @returns {{ x: number, y: number }} координаты для left/top fixed-меню
 */
export const getContextMenuPosition = (
  event,
  {
    menuWidth = 220,
    menuHeight = 44,
    viewportWidth = window.innerWidth,
    viewportHeight = window.innerHeight,
    offset = 8,
  } = {}
) => {
  const eventX = Number(event?.clientX);
  const eventY = Number(event?.clientY);
  const minX = offset;
  const minY = offset;
  const maxX = Math.max(minX, viewportWidth - menuWidth - offset);
  const maxY = Math.max(minY, viewportHeight - menuHeight - offset);

  return {
    x: Math.min(Math.max(Number.isNaN(eventX) ? minX : eventX, minX), maxX),
    y: Math.min(Math.max(Number.isNaN(eventY) ? minY : eventY, minY), maxY),
  };
};
